export default "/images/logo-ecole.svg?aff8b621552843b166cea415647373f2";